import BreadCrumb from "Components/Common/BreadCrumb"
import { ProductsPage } from "features/products"
import { Container } from "reactstrap"
import { BaseErrorBoundary } from "Components/errorBoundary"
import { ProductSearchBar } from "features/products/components/common/ProductSearchBar"
// import TestModuleErrorBoundary from "Components/errorBoundary/TestModuleErrorBoundary"
// import TestErrorBoundary from "Components/errorBoundary/TestErrorBoundary"

const Products = () => {
  return (
    <div className="page-content">
      <Container fluid>
          <BreadCrumb title={"Products"} pageTitle={"Modules"} searchComponent={<ProductSearchBar />} />
          
          {/* Module Error Boundary Test Component - Only shows in development */}
          {/* <TestModuleErrorBoundary /> */}
          
          {/* adding error boundary to the products page */}
          <BaseErrorBoundary 
            level="module" 
            moduleName="Products"
          >
            <ProductsPage />
          </BaseErrorBoundary>
        </Container>
      
    </div>
  )
}
export default Products